import {
  faAdd,
  faEdit,
  faEye,
  faRetweet,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import CreateModal from "../modals/CreateModal";
import DetailModal from "../modals/DetailModal";
import { Pagination } from "../../../../Components/Pagination";
import { socket } from "../../../../redux/configs/socket";
import { read } from "xlsx-js-style";

export default function ApiList() {
  const defaultDate = moment();
  const formatted = moment(defaultDate).format("YYYY-MM-DDTHH:mm");

  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: "Active",
      apiMethod: "GET",
      direction: "ERP->RFID",
      repeatTime: {
        days: 0,
        hours: 0,
        minutes: 0,
      },
      startTime: formatted,
    },
  });
  const { auth, proxy, lang } = useSelector((s) => s);
  const [daysOptions, setDaysOptions] = useState([]);
  const [startTimeOptions, setStartTimeOptions] = useState([]);
  const [hoursOptions, setHoursOptions] = useState([]);
  const [minutesOptions, setMinutesOptions] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [detail, setDetail] = useState({});
  const [edit, setEdit] = useState();
  const token = localStorage.getItem("_token");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 11;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const [total, setTotal] = useState(0);

  const paginate = (pageNumber) => {
    setSearch((prev) => ({
      ...prev,
      page: pageNumber,
    }));
    setCurrentPage(pageNumber);
  };

  const [search, setSearch] = useState({
    page: 1,
    limit: 11,
  });
  const headers = [
    "Tên API",
    "URL API",
    "Trạng Thái",
    "Thời Gian Đặt",
    "Đếm Ngược",
    "Hướng",
    "Phương THức",
    "Ghi Chú",
    "Ngày Tạo",
    "Người Tạo",
  ];
  useEffect(() => {
    const queryString = new URLSearchParams(search).toString();

    if (search) {
      const handler = setTimeout(() => {
        callApi(queryString);
      }, 700);
      return () => clearTimeout(handler);
    } else {
      callApi(queryString);
    }
  }, [refresh, search]);

  const callApi = (queryString) => {
    fetch(proxy() + `/api/SyncData?${queryString}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    })
      .then((res) => res.json())
      .then((response) => {
        const { success, data, total } = response || {};
        setData(data);
        setTotal(total);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const days = [];
    for (let i = 0; i <= 7; i++) {
      days.push({
        value: i.toString(),
        label: `${i} days`,
      });
    }
    setDaysOptions(days);

    const hours = [];
    for (let i = 0; i <= 23; i++) {
      hours.push({
        value: i.toString(),
        label: `${moment().startOf("day").add(i, "hours").format("HH")} hours`,
      });
    }
    setHoursOptions(hours);

    const minutes = [];
    for (let i = 0; i < 60; i++) {
      minutes.push({
        value: i.toString(),
        label: `${moment()
          .startOf("day")
          .add(i, "minutes")
          .format("mm")} minutes`,
      });
    }
    setMinutesOptions(minutes);
  }, [refresh]);

  const fields = [
    {
      id: "apiName",
      label: "Tên API",
      type: "text",
      validation: { required: "Tên API không được trống" },
      register: "apiName",
    },
    {
      id: "endPoint",
      label: "URL API",
      type: "text",
      validation: { required: "URL API không được trống" },
      register: "endPoint",
    },
    {
      id: "repeatTime",
      label: "Thời Gian Đặt",
      type: "groups",
      validation: { required: "Thời Gian Đặt không được trống" },
      register: "repeatTime",
      groups: [
        {
          id: "days",
          label: "Ngày",
          type: "number",
          register: "days",
          options: daysOptions,
        },
        {
          id: "hours",
          label: "Giờ",
          type: "number",
          register: "hours",
          options: hoursOptions,
        },
        {
          id: "minutes",
          label: "Phút",
          type: "number",
          validation: { required: "Phút không được trống" },
          register: "minutes",
          options: minutesOptions,
        },
      ],
    },
    {
      id: "startTime",
      label: "Thời Gian bắt đầu",
      type: "datetime-local",
      // validation: { required: "Thời Gian Bắt Đầu không được trống" },
      register: "startTime",
    },
    {
      id: "direction",
      label: "Hướng",
      type: "select",
      options: [
        { value: "ERP->RFID", label: "ERP-RFID", selected: true },
        { value: "RFID->ERP", label: "RFID-ERP" },
      ],
      register: "direction",
    },
    {
      id: "apiMethod",
      label: "Phương Thức",
      type: "select",
      options: [
        { value: "GET", label: "GET", selected: true },
        // { value: "POST", label: "POST" },
        // { value: "PUT", label: "PUT" },
        // { value: "DELETE", label: "DELETE" },
      ],
      register: "apiMethod",
    },
    {
      id: "status",
      label: "Trạng Thái",
      type: "select",
      options: [
        { value: "Active", label: "Kích hoạt", selected: true },
        { value: "Inactive", label: "Không hoạt động" },
        { value: "Waiting", label: "Hàng đợi", disabled: true },
      ],
      // validation: {
      //   setValueAs: (v) => {
      //     if (typeof v === "boolean") return v;
      //     if (typeof v === "string") return v === "true";
      //     return false;
      //   },
      // },
      register: "status",
    },
    {
      id: "note",
      label: "Ghi Chú",
      type: "textarea",
      register: "note",
    },
  ];

  const onSubmit = async (data) => {
    const { days, hours, minutes } = data?.repeatTime || {};

    const mappedData = {
      ...data,
      endPoint: data.endPoint.trim(),
      apiName: data?.apiName.trim(),
      note: data?.note && data?.note.trim(),
      direction: data?.direction?.value || data?.direction,
      method: data?.apiMethod?.value || data?.apiMethod,
      status: data?.status?.value || data?.status,
      repeatTime: {
        days: parseInt(days, 10) || 0,
        hours: parseInt(hours, 10) || 0,
        minutes: parseInt(minutes, 10),
      },
    };

    fetch(proxy() + `/api/SyncData`, {
      method: edit ? "PUT" : "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: mappedData,
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        const { success, data, message } = response || {};

        if (success) {
          if (edit) {
            setData((prev) =>
              prev.map((item) =>
                item.apiID === data.apiID ? { ...item, ...data } : item
              )
            );
          }

          Swal.fire({
            title: lang["success"] || "Success",
            text: message,
            icon: "success",
            timer: 500,
          }).then(() => {
            if (!edit) {
              if (data) {
                setData((prev = []) => [...prev, data]);
                setRefresh((prev) => prev + 1);
                reset({
                  apiName: "",
                  endPoint: "",
                  repeatTime: {
                    days: 0,
                    hours: 0,
                    minutes: 0,
                  },
                  direction: "ERP->RFID",
                  apiMethod: "GET",
                  status: "Active",
                  note: "",
                  startTime: formatted,
                });
              }
            }
          });
        } else {
          Swal.fire({
            title: lang["error"] || "Error",
            text: message,
            icon: "error",
            showConfirmButton: true,
          });
        }
      });
  };
  const handleDelete = async (index) => {
    const item = data[index];
    const { apiName } = item || {};
    const confirmDelete = await Swal.fire({
      title: `Bạn có chắc muốn xóa API "${apiName}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Xóa",
      cancelButtonText: "Hủy",
    });

    if (confirmDelete.isConfirmed) {
      fetch(proxy() + `/api/SyncData/${item.apiID}`, {
        method: "DELETE",
        headers: {
          Authorization: token,
        },
      })
        .then((res) => res.json())
        .then((response) => {
          const { success, message } = response || {};
          if (success) {
            setData((prev) => prev.filter((_, i) => i !== index));
            Swal.fire({
              title: lang["success"] || "Success",
              text: message,
              icon: "success",
              timer: 500,
            });
          } else {
            Swal.fire({
              title: lang["error"] || "Error",
              text: message,
              icon: "error",
              showConfirmButton: true,
            });
          }
        });
    }
  };

  const status =
    data && data.length && data.every(({ status }) => status !== "Inactive");

  const handleStartServer = () => {
    fetch(proxy() + `/api/SyncData/server`, {
      method: "PUT",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data, status }),
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        setData(data);
      })
      .finally(() => setRefresh((prev) => prev + 1));
  };
  return (
    <>
      <div className="actions mb-2 d-flex flex-column align-items-end">
        <button
          className={`btn btn-${!status ? "success" : "danger"}`}
          onClick={handleStartServer}
        >
          {status ? "Dừng Server" : "Khởi động Server"}
        </button>
        <div className="d-flex">
          <button
            className="btn btn-warning mr-2"
            onClick={() => {
              setCurrentPage(1);
              setSearch({});
              setRefresh((prev) => prev + 1);
            }}
          >
            <FontAwesomeIcon icon={faRetweet} />
          </button>
          <button
            className="btn btn-success"
            data-toggle="modal"
            data-target="#createApiModal"
            onClick={() => setEdit(null)}
          >
            <FontAwesomeIcon icon={faAdd} />
          </button>
        </div>

        {/* <div>
          <button className="btn btn-success mr-2">GetAll</button>
          <button className="btn btn-success mr-2">GetByDate</button>
          <button className="btn btn-success">GetById</button>
        </div> */}
      </div>
      <table
        className="table-responsive table-custom design-table w-100"
        style={{
          height: "70vh",
          overflow: "auto",
          // overflowX: "hidden",
        }}
      >
        <thead>
          <tr>
            <td className="algin-center">#</td>
            {headers.map((header, index) => (
              <td
                key={index}
                className="align-center"
                style={{
                  position: index == 0 && "sticky",
                  left: index == 0 && "-1px",
                }}
              >
                {header}
              </td>
            ))}
            <td
              className="align-center"
              style={{
                position: "sticky",
                right: 0,
              }}
            >
              Thao Tác
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            {[
              { key: "apiName", type: "text" },
              { key: "endPoint", type: "text" },
              { key: "status", type: "text" },
              { key: "", type: "empty" },
              { key: "", type: "empty" },
              { key: "", type: "empty" },
              { key: "apiMethod", type: "text" },
              { key: "note", type: "text" },
              { key: "ngayTao", type: "date" },
              { key: "nguoiTao", type: "text" },
            ].map((item, index) => (
              <td
                key={index}
                style={{
                  position: index == 0 && "sticky",
                  left: index == 0 && "-1px",
                  backgroundColor: index == 0 && "white",
                }}
              >
                {item.key ? (
                  <input
                    type={item.type}
                    className="form-control"
                    onChange={(e) => {
                      const value = e.target.value.trim();
                      setSearch((prev) => ({
                        ...prev,
                        [item.key]: value,
                      }));
                    }}
                    value={search[item.key] || ""}
                  />
                ) : null}
              </td>
            ))}
            <td
              style={{
                position: "sticky",
                right: 0,
                backgroundColor: "white",
              }}
            ></td>
          </tr>
          {loading ? (
            <td className="align-center" colSpan={headers.length + 2}>
              <img
                width="40px"
                className="mb-1"
                src="/images/icon/load.gif"
                alt="Loading..."
              />
            </td>
          ) : data && data.length ? (
            data.map((item, index) => {
              const {
                apiName,
                endPoint,
                status,
                repeatTime,
                direction,
                frequency,
                apiMethod,
                note,
                ngayTao,
                nguoiTao,
                // createdTime,
                // creator,
              } = item || {};

              const duration = moment.duration({
                days: repeatTime?.days,
                hours: repeatTime?.hours,
                minutes: repeatTime?.minutes,
              });
              const formattedTime = `${duration.days()} Ngày ${duration.hours()} Giờ ${duration.minutes()} Phút`;

              return (
                <tr key={index}>
                  <td
                    className="align-center"
                    style={{
                      position: "sticky",
                      left: "-1px",
                      backgroundColor: "white",
                    }}
                  >
                    {indexOfFirstData + index + 1}
                  </td>
                  <td
                    style={{
                      position: "sticky",
                      left: "-1px",
                      backgroundColor: "white",
                    }}
                  >
                    {apiName}
                  </td>
                  <td
                    style={{
                      maxWidth: "300px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={endPoint}
                  >
                    {endPoint}
                  </td>
                  <td className="align-center">
                    <CountdownDisplay
                      jobId={item?.intervalID}
                      status={status}
                      isStatus={true}
                      lang={lang}
                    />
                  </td>
                  <td className="align-center">{formattedTime}</td>
                  <td className="align-center">
                    <CountdownDisplay jobId={item?.intervalID} lang={lang} />
                  </td>
                  <td className="align-center">{direction}</td>
                  <td className="align-center">{apiMethod}</td>
                  <td>{note}</td>
                  <td className="align-center">
                    {moment(ngayTao).utc().format("DD/MM/YYYY HH:mm:ss")}
                  </td>
                  <td className="align-center">{nguoiTao}</td>
                  <td
                    className="align-center"
                    style={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "white",
                    }}
                  >
                    <button
                      className="btn btn-primary mr-2 m-0"
                      onClick={() => setEdit(item)}
                      data-toggle="modal"
                      data-target="#createApiModal"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      className="btn btn-danger mr-2 m-0"
                      onClick={() => handleDelete(index)}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                    <button
                      className="btn btn-success m-0"
                      data-toggle="modal"
                      data-target="#detailApiModal"
                      onClick={() => setDetail(item)}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td className="align-center" colSpan={headers.length + 2}>
                {lang["not found data"]}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {data && data.length ? (
        <Pagination
          total={total}
          itemsPerPage={dataPerPage}
          currentPage={currentPage}
          paginate={paginate}
          lang={lang}
        />
      ) : null}
      <CreateModal
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        errors={errors}
        fields={fields}
        register={register}
        isEdit={edit ? true : false}
        edit={edit}
        getValues={getValues}
        setValue={setValue}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        watch={watch}
        reset={reset}
        control={control}
        Controller={Controller}
      />
      <DetailModal data={detail} />
    </>
  );
}

function CountdownDisplay({ jobId, status: STT, isStatus, lang }) {
  const [secondsLeft, setSecondsLeft] = useState(null);
  const [status, setStatus] = useState(STT);

  useEffect(() => {
    const listener = ({ jobId: incomingId, status: stt, secondsLeft }) => {
      if (incomingId === jobId) {
        setSecondsLeft(secondsLeft);
        if (stt) {
          setStatus(stt);
        } else {
          setStatus(STT);
        }
      }
    };

    socket.on("job-api", listener);
    setStatus(STT);
    return () => {
      socket.off("job-api", listener);
    };
  }, [jobId, STT]);

  const statusStyles = {
    Waiting: {
      borderColor: "#ffce02",
      backgroundColor: "#ffce02",
      color: "#086d46",
    },
    Fetching: {
      borderColor: "#0069d9",
      backgroundColor: "#0069d9",
      color: "white",
    },
    Active: {
      borderColor: "#086d46",
      backgroundColor: "#086d46",
      color: "white",
    },
    Error: {
      borderColor: "red",
      backgroundColor: "red",
      color: "white",
    },
  };

  const currentStyle = statusStyles[status] || statusStyles["Error"];
  return isStatus ? (
    <span
      style={{
        border: `1px solid ${currentStyle.borderColor}`,
        borderRadius: "12px",
        padding: "2px 5px",
        backgroundColor: currentStyle.backgroundColor,
        color: currentStyle.color,
      }}
    >
      {lang[status] || status}
    </span>
  ) : (
    formatTime(secondsLeft)
  );
}

const formatTime = (seconds) => {
  const duration = moment.duration(seconds, "seconds");
  const hours = String(duration.hours()).padStart(2, "0");
  const minutes = String(duration.minutes()).padStart(2, "0");
  const secs = String(duration.seconds()).padStart(2, "0");
  return `${hours}h ${minutes}m ${secs}s`;
};
